// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"67faf6fc","629":"73ef7480"}[chunkId] + ".chunk.css";
};